import { Box } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { Info } from '../components/Info';
import { ServiceList } from '../components/ServiceList';

export const Home = () => {
  return (
    <>
      <Box h={'66px'}>
        <Header headerText="Maven Note" showBurger={true} />
      </Box>

      <Box mx={'21px'}>
        <Info />
        <ServiceList />
      </Box>
    </>
  );
};
